﻿export class Stepper {
    constructor(stepper) {
        this.stepper = $(stepper);
        this.changeStep(0);
    }

    get index() {
        return $("> [data-step]", this.stepper).index(this.activeStep);
    }

    next() {
        this.changeStep(this.index + 1);
    }

    prev() {
        this.changeStep(this.index - 1);
    }

    changeStep(index) {
        const steps = $("> [data-step]", this.stepper);

        if (steps.length === 0) {
            return;
        }

        if (index < 0) {
            index = 0;
        }

        if (index >= steps.length) {
            index = steps.length - 1;
        }

        const step = steps.get(index);

        this.stepper.fadeOut(200, () => {
            if (this.activeStep) {
                this.activeStep.removeClass("aw-step--active");
            }
            
            this.activeStep = $(step);
            this.activeStep.addClass("aw-step--active").trigger("show");
            this.stepper.fadeIn(200);
        });
    }
}